export var VIDEO_STATES;
(function (VIDEO_STATES) {
    VIDEO_STATES["VISIBLE"] = "visible";
    VIDEO_STATES["DRAFT"] = "draft";
    VIDEO_STATES["OVER_QUOTA"] = "over-quota";
    VIDEO_STATES["DELETED"] = "deleted";
})(VIDEO_STATES || (VIDEO_STATES = {}));
//# sourceMappingURL=video-states.js.map